import { Asset } from "../modules/assets/types";

// // // //

export function getAssetURL(props: {
    asset: Asset | { ticker: null | string; slug: null | string };
}): string {
    const { asset } = props;
    return `/assets/${asset.ticker || asset.slug}`;
}
